#import '../fragments/user-table-fragment.graphql'

query GetUsersByFilter($first: Int, $after: String, $statusFilter: Int, $roleId: String) {
    usersByFilter(first: $first, after: $after, statusFilter: $statusFilter, roleId: $roleId) {
        pageInfo {
            __typename
            endCursor
            hasNextPage
        }
        totalCount
        edges {
            node {
                ...UserTableFragment
            }
        }
    }
}
